import * as actions from "../action.constants";

const requestNotifications = () => ({
  type: actions.REQUEST_NOTIFICATIONS,
});

const saveNotifications = (data) => ({
  type: actions.STORE_NOTIFICATIONS,
  responsePayload: data,
});

const markNotificationAsRead = (id) => ({
  type: actions.MARK_NOTIFICATION_READ,
  payload: id,
});

const markAllNotificationAsRead = () => ({
  type: actions.MARK_ALL_NOTIFICATION_READ,
});

const deleteNotifications = (callback) => ({
  type: actions.DELETE_NOTIFICATIONS,
  callback,
});

export {
  requestNotifications,
  saveNotifications,
  markNotificationAsRead,
  markAllNotificationAsRead,
  deleteNotifications,
};
